export default __webpack_public_path__ + "static/media/MobilyLogo.a482491c.svg";